import { cloneDeep } from 'lodash';
import {
	AvatarLike,
	initializeEditSnapshotWithAvatarFallback,
	RunnitLike,
	initializeNoSourceCreateSnapshot,
	TemplateDialogInitSnapshot,
} from './parityHarness';

export async function initializeCreateWorkflowNoSource (
	getRandomDefaultAvatar: () => Promise<AvatarLike | null>,
): Promise<TemplateDialogInitSnapshot> {
	return initializeNoSourceCreateSnapshot(getRandomDefaultAvatar);
}

export async function initializeEditWorkflowWithAvatarFallback (
	runnit: RunnitLike,
	getRandomDefaultAvatar: () => Promise<AvatarLike | null>,
): Promise<Omit<TemplateDialogInitSnapshot, 'currentRunnitNodes' | 'selectedResults'>> {
	return initializeEditSnapshotWithAvatarFallback(runnit, getRandomDefaultAvatar);
}

/** Create-template flow: clone metadata from an existing runnit/board (not edit-template mode). */
export async function initializeCloneFromSourceWorkflow (
	runnit: RunnitLike,
	getRandomDefaultAvatar: () => Promise<AvatarLike | null>,
): Promise<Omit<TemplateDialogInitSnapshot, 'currentRunnitNodes' | 'selectedResults'>> {
	const templateTitle = `${runnit.title} (Copy)`;
	const templateDescription = runnit.description ?? null;
	const templateOnboardingData = cloneDeep(runnit.onboardingData || {});
	const templateCustomFields = cloneDeep(runnit.customFields || {});

	let templateAvatarId: string | null = null;
	let templateAvatar: AvatarLike | null = null;

	if (runnit.avatarId && runnit.avatar) {
		templateAvatarId = runnit.avatarId;
		templateAvatar = runnit.avatar;
	} else {
		const chosenRandomAvatar = await getRandomDefaultAvatar();
		if (chosenRandomAvatar) {
			templateAvatarId = chosenRandomAvatar.id;
			templateAvatar = chosenRandomAvatar;
		}
	}

	return {
		templateTitle,
		templateDescription,
		templateOnboardingData,
		templateCustomFields,
		templateAvatarId,
		templateAvatar,
		currentStep: 1,
	};
}
